const CryptoJS = window.CryptoJS;
// eslint-disable-next-line
export default {
  encrypt(str) {
    const enc = CryptoJS.AES.encrypt(
      str,
      CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV_KEY), // parse the IV
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
      }
    );
    return enc.toString();
  },
  decrypt(str) {
    const dec = CryptoJS.AES.decrypt(
      str,
      CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV_KEY), // parse the IV CLIENT
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
      }
    );
    return dec.toString(CryptoJS.enc.Utf8);
  },
  encryptClient(str) {
    const enc = CryptoJS.AES.encrypt(
      str,
      CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_KEY_CLIENT),
      {
        iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV_KEY_CLIENT), // parse the IV CLIENT
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
      }
    );
    return enc.toString();
  },
  decryptClient(str) {
    const dec = CryptoJS.AES.decrypt(
      str,
      CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_KEY_CLIENT),
      {
        iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV_KEY_CLIENT), // parse the IV CLIENT
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
      }
    );
    return dec.toString(CryptoJS.enc.Utf8);
  },
  isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  },
  makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  },
  phoneNumberNormalization(phone) {
    phone = String(phone).trim();
    if (phone.startsWith("0")) {
      phone = "+62" + phone.slice(1);
    } else if (phone.startsWith("62")) {
      phone = "+" + phone;
    } else {
      phone = "+62" + phone;
    }
    return phone.replace(/[- .]/g, "");
  },
};
